module.exports = __webpack_public_path__ + "static/award4-a0be6c7f9a0393f1846f075e5784aff3.png";